import { useState, useEffect } from 'react';
import apiClient from '../api/client';

export const useUsage = () => {
  const [usage, setUsage] = useState({
    projects_count: 0,
    ai_improvements_used: 0,
    subscription_status: 'free',
    can_create_project: true,
    can_use_ai_improvement: true,
    projects_remaining: 10,
    ai_improvements_remaining: 20
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsage = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiClient.get('/usage');
      setUsage(response.data);
    } catch (err) {
      console.error('Error fetching usage:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsage();
  }, []);

  const refreshUsage = () => {
    fetchUsage();
  };

  return {
    usage,
    loading,
    error,
    refreshUsage
  };
};